/* Caïman & Co — product page interactions: gallery, variants, leather, colours, signature */
(function () {
  var MATTE = "Crocodile / Alligator — Matte";
  var SHINY = "Crocodile / Alligator — Shiny";
  var LIZARD = "Lizard";
  var OSTRICH = "Ostrich";

  var COLOURS = {};
  COLOURS[MATTE] = [
    { code: "100", name: "Black", hex: "#131211" },
    { code: "101", name: "Tan", hex: "#6E3A2C" },
    { code: "102", name: "Stone", hex: "#8C97A1" },
    { code: "103", name: "Jade", hex: "#159C7E" },
    { code: "104", name: "Navy", hex: "#3B4360" },
    { code: "116", name: "Etoupe", hex: "#7C7359" },
    { code: "117", name: "Rose", hex: "#B75465" },
    { code: "150", name: "Himalaya", hex: "#D8D6D2" }
  ];
  COLOURS[SHINY] = [
    { code: "101G", name: "Black", hex: "#0E0D0D" },
    { code: "106G", name: "Emerald", hex: "#14634A" },
    { code: "107G", name: "Burgundy", hex: "#6A1C35" },
    { code: "108G", name: "Denim", hex: "#2F4C67" },
    { code: "154G", name: "Graphite", hex: "#787A6E" },
    { code: "109G", name: "Chocolate", hex: "#5A2E17" },
    { code: "110G", name: "Olive", hex: "#4B4F1E" }
  ];
  COLOURS[LIZARD] = [
    { code: "200", name: "Black", hex: "#151513" },
    { code: "N201", name: "Natural", hex: "#8E8C86" },
    { code: "202", name: "Burgundy", hex: "#6B2233" },
    { code: "203", name: "Emerald", hex: "#134536" },
    { code: "210", name: "Wood", hex: "#4A362C" }
  ];
  COLOURS[OSTRICH] = [
    { code: "300", name: "Black", hex: "#1D2129" },
    { code: "302", name: "Chocolate", hex: "#573A2C" },
    { code: "305", name: "Jade", hex: "#0F9C74" },
    { code: "304", name: "Brick", hex: "#C25327" },
    { code: "306", name: "Stone", hex: "#6E7671" },
    { code: "307", name: "Burgundy", hex: "#7A5459" },
    { code: "310", name: "Sakura", hex: "#E3AFC0" },
    { code: "311", name: "Antelope", hex: "#E7BE86" },
    { code: "312", name: "Sage", hex: "#8E9271" }
  ];

  var LEATHER_TYPES = [MATTE, SHINY, LIZARD, OSTRICH];

  function withFinish(list, finish) {
    return list.map(function (c) {
      return { code: c.code, hex: c.hex, name: c.name + " — " + finish };
    });
  }

  function coloursFor(leather) {
    if (!leather) return [];
    if (COLOURS[leather]) return COLOURS[leather];
    var t = leather.toLowerCase();
    if (t.indexOf("crocodile") > -1 || t.indexOf("alligator") > -1 || t.indexOf("caiman") > -1) {
      if (t.indexOf("matte") > -1) return COLOURS[MATTE];
      if (t.indexOf("shiny") > -1 || t.indexOf("glossy") > -1) return COLOURS[SHINY];
      return withFinish(COLOURS[MATTE], "Matte").concat(withFinish(COLOURS[SHINY], "Shiny"));
    }
    if (t.indexOf("lizard") > -1) return COLOURS[LIZARD];
    if (t.indexOf("ostrich") > -1) return COLOURS[OSTRICH];
    return [];
  }

  function chartFor(leather, charts) {
    if (!leather) return null;
    var t = leather.toLowerCase();
    if (t.indexOf("shiny") > -1 || t.indexOf("glossy") > -1) return charts.shiny;
    if (t.indexOf("crocodile") > -1 || t.indexOf("alligator") > -1) return charts.matte;
    if (t.indexOf("lizard") > -1) return charts.lizard;
    if (t.indexOf("ostrich") > -1) return charts.ostrich;
    return null;
  }

  function init(root) {
    var data = JSON.parse(root.querySelector("[data-product-json]").textContent);
    var charts = JSON.parse(root.querySelector("[data-charts-json]").textContent);
    var variants = data.variants || [];
    var optionNames = data.options || [];
    var leatherOptionName = null;
    optionNames.forEach(function (n) {
      if (String(n).toLowerCase().indexOf("leather") > -1) leatherOptionName = n;
    });
    var hasLeatherOption = !!leatherOptionName;

    /* ---------- gallery ---------- */
    var main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-thumb]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        if (main) {
          main.src = btn.getAttribute("data-full");
          main.alt = btn.getAttribute("data-alt") || main.alt;
        }
      });
    });

    /* ---------- variants ---------- */
    var chosen = {};
    var startVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
    (startVariant ? startVariant.options : []).forEach(function (v, i) {
      chosen[optionNames[i]] = v;
    });

    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price]");
    var addBtn = root.querySelector("[data-add]");

    function currentVariant() {
      return variants.filter(function (v) {
        return optionNames.every(function (name, i) { return chosen[name] === v.options[i]; });
      })[0] || variants[0];
    }

    function renderVariant() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to selection" : "Made to order — enquire";
      }
      root.querySelectorAll("[data-option-group]").forEach(function (group) {
        var name = group.getAttribute("data-option-group");
        var label = group.querySelector("[data-option-value]");
        if (label) label.textContent = chosen[name] || "";
        group.querySelectorAll("[data-option-btn]").forEach(function (btn) {
          btn.classList.toggle("is-active", btn.getAttribute("data-value") === chosen[name]);
        });
      });
    }

    root.querySelectorAll("[data-option-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest("[data-option-group]");
        var name = group.getAttribute("data-option-group");
        chosen[name] = btn.getAttribute("data-value");
        renderVariant();
        if (name === leatherOptionName) { selectedColour = null; renderColours(); }
      });
    });

    /* ---------- leather + colours ---------- */
    var leatherWrap = root.querySelector("[data-leather]");
    var leatherType = hasLeatherOption ? chosen[leatherOptionName] : MATTE;
    var selectedColour = null;

    if (leatherWrap && !hasLeatherOption) {
      LEATHER_TYPES.forEach(function (type) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "opt-btn" + (type === leatherType ? " is-active" : "");
        b.textContent = type;
        b.addEventListener("click", function () {
          leatherType = type;
          selectedColour = null;
          leatherWrap.querySelectorAll(".opt-btn").forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
          var lbl = root.querySelector("[data-leather-value]");
          if (lbl) lbl.textContent = type;
          var hid = root.querySelector("[data-leather-input]");
          if (hid) hid.value = type;
          renderColours();
        });
        leatherWrap.appendChild(b);
      });
      var hid0 = root.querySelector("[data-leather-input]");
      if (hid0) hid0.value = leatherType;
      var lbl0 = root.querySelector("[data-leather-value]");
      if (lbl0) lbl0.textContent = leatherType;
    } else if (leatherWrap) {
      leatherWrap.closest("[data-leather-block]").hidden = true;
    }

    var colourBlock = root.querySelector("[data-colour-block]");
    var colourWrap = root.querySelector("[data-colours]");
    var colourInput = root.querySelector("[data-colour-input]");
    var colourValue = root.querySelector("[data-colour-value]");
    var signatureBlock = root.querySelector("[data-signature-block]");
    var chartLink = root.querySelector("[data-chart-link]");
    var chartImg = root.querySelector("[data-chart-img]");

    function activeLeather() { return hasLeatherOption ? chosen[leatherOptionName] : leatherType; }

    function renderColours() {
      if (!colourWrap) return;
      var list = coloursFor(activeLeather());
      colourWrap.innerHTML = "";
      if (colourInput) colourInput.value = "";
      if (colourValue) colourValue.textContent = "Select";
      if (!list.length) {
        if (colourBlock) colourBlock.hidden = true;
        if (signatureBlock) signatureBlock.hidden = true;
        return;
      }
      if (colourBlock) colourBlock.hidden = false;
      if (signatureBlock) signatureBlock.hidden = false;

      list.forEach(function (c) {
        var label = c.name + " (ref. " + c.code + ")";
        var b = document.createElement("button");
        b.type = "button";
        b.className = "swatch";
        b.title = label;
        b.setAttribute("aria-label", label);
        b.innerHTML = '<span class="swatch__chip" style="background:' + c.hex + '"></span><span class="swatch__name">' + c.name + "</span>";
        b.addEventListener("click", function () {
          selectedColour = label;
          if (colourInput) colourInput.value = label;
          if (colourValue) colourValue.textContent = label;
          colourWrap.querySelectorAll(".swatch").forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
        });
        colourWrap.appendChild(b);
      });

      var chart = chartFor(activeLeather(), charts);
      if (chartLink && chartImg) {
        if (chart) {
          chartLink.hidden = false;
          chartImg.src = chart;
          chartImg.hidden = true;
          chartLink.textContent = "View the colour chart";
        } else {
          chartLink.hidden = true;
          chartImg.hidden = true;
        }
      }
    }

    if (chartLink && chartImg) {
      chartLink.addEventListener("click", function () {
        chartImg.hidden = !chartImg.hidden;
        chartLink.textContent = chartImg.hidden ? "View the colour chart" : "Hide the colour chart";
      });
    }

    /* ---------- signature ---------- */
    var sig = root.querySelector("[data-signature]");
    if (sig) {
      sig.addEventListener("input", function () {
        sig.value = sig.value.replace(/[^a-zA-Z]/g, "").slice(0, 2).toUpperCase();
      });
    }

    /* ---------- quantity ---------- */
    var qty = root.querySelector("[data-qty]");
    root.querySelectorAll("[data-qty-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = parseInt(btn.getAttribute("data-qty-step"), 10);
        var next = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + step));
        qty.value = next;
      });
    });

    /* ---------- require colour ---------- */
    var form = root.querySelector("[data-product-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (colourBlock && !colourBlock.hidden && !selectedColour) {
          e.preventDefault();
          var note = root.querySelector("[data-colour-error]");
          if (note) note.hidden = false;
          colourBlock.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }

    renderVariant();
    renderColours();
  }

  document.querySelectorAll("[data-product-root]").forEach(init);
})();
